import {Reservation} from "./Reservation";
import {Slot} from "./Slot";
import {Key} from "../../../../typescript-plugin/entities/Key";
import {IdKey} from "../../../../typescript-plugin/entities/IdKey";
import {IEntity} from "../../../../typescript-plugin/entities/IEntity";

export class Calendar implements IEntity{
    public id:string;
    public vanId:string;
    public reservations:Array<Reservation>;

    constructor(){
        this.reservations = [];
    }

    public Key(): Key {
        return new IdKey(this.id);
    }

    public Serialize(): {} {
        return {
            id: this.id,
            Items: this.SerializeReservations()
        };
    }

    public Deserialize(data: {}): void {
        this.id = data['id'];
        this.DeserializeReservations(data);
    }

    public ToPersistable(): {} {
        return {
            id: this.id,
            vanId: this.vanId
        };
    }

    public ToEntity(data: {}): void {
        this.id = data['id'];
        this.vanId = data['vanId'];
    }

    public AsFake(): Calendar{
        this.id = "CalendarId";
        this.vanId = "VanId";
        this.reservations = [new Reservation(), new Reservation()];
        this.reservations[0].slot = new Slot("2018-10-3-AM");
        this.reservations[1].slot = new Slot("2018-10-3-PM");
        return this;
    }

    private SerializeReservations():any{
        let reservationsSerialized:Array<{}> = [];
        for(let reservation of this.reservations){
            reservationsSerialized.push(reservation.Serialize());
        }
        return reservationsSerialized;
    }

    private DeserializeReservations(data:{}):any{
        this.reservations = [];
        for(let serializedReservation of data['Items']){
            let reservation:Reservation = new Reservation();
            reservation.Deserialize(serializedReservation);
            this.reservations.push(reservation);
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/calendar/Calendar.ts